import { Controller } from '@hotwired/stimulus'
import WaveSurfer from 'wavesurfer.js'

let currentPlayer = null

export default class extends Controller {
  static targets = ['waveform', 'playButton', 'duration']

  static values = {
    url: String
  }

  connect() {
    this.player = WaveSurfer.create({
      container: this.waveformTarget,
      height: 36,
      barWidth: 3,
      barGap: 2,
      barRadius: 2,
      normalize: true,
      waveColor: '#9a7a9c',
      progressColor: '#f773c5',
      cursorWidth: 0
    })

    this.player.load(this.urlValue)

    this.player.on('ready', () => {
      const seconds = this.player.getDuration()

      this.durationTarget.textContent = this.format(0)
    })


    this.player.on('timeupdate', (currentTime) => {
      this.durationTarget.textContent = this.format(currentTime)
    })

    this.player.on('finish', () => {
      this.playButtonTarget.innerHTML = '<svg width="20" height="20" viewBox="0 0 256 256" class="#{classname}" fill="none" xmlns="http://www.w3.org/2000/svg">\n          <path fill="black" d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/>\n        </svg>'
      this.durationTarget.textContent = this.format(0)
    })

    this.player.on('finish', () => {
      this.playButtonTarget.innerHTML = '<svg width="20" height="20" viewBox="0 0 256 256" class="#{classname}" fill="none" xmlns="http://www.w3.org/2000/svg">\n          <path fill="black" d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/>\n        </svg>'
      this.durationTarget.textContent = this.format(0)
    })
  }

  toggle() {
    if (currentPlayer && currentPlayer !== this) {
      currentPlayer.player.pause()
      currentPlayer.playButtonTarget.innerHTML = '<svg width="20" height="20" viewBox="0 0 256 256" class="#{classname}" fill="none" xmlns="http://www.w3.org/2000/svg">\n          <path fill="black" d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/>\n        </svg>'
    }

    currentPlayer = this

    this.player.playPause()

    this.playButtonTarget.innerHTML = this.player.isPlaying() ? '<svg width="20" height="20" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '        <path fill="black" d="M216,48V208a16,16,0,0,1-16,16H160a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h40A16,16,0,0,1,216,48ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Z"/>\n' +
      '      </svg>' : '<svg width="20" height="20" viewBox="0 0 256 256" class="#{classname}" fill="none" xmlns="http://www.w3.org/2000/svg">\n          <path fill="black" d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/>\n        </svg>'
  }

  format(seconds) {
    const m = Math.floor(seconds / 60)
    const s = Math.floor(seconds % 60)

    return `${m}:${s.toString().padStart(2, '0')}`
  }
}
